/**
 * Metadata type dropdown — OrgPilot local copy.
 * Simple select dropdown for choosing a metadata type.
 */
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@ncoder/ui";

import clsx from "clsx";

type OptionValue = { id: string; name: string } | null;

type Props = {
  options: any[];
  value: OptionValue;
  setValue: any;
  className?: string;
  placeholder?: string;
};

export const ChatTypeDropdown = ({
  className,
  options,
  value,
  setValue,
  placeholder = "select a metadata type",
}: Props) => {
  const handleValueChange = (selectedId: string) => {
    // Find the option and call setValue with the full object
    const option = options.find((opt: any) => String(opt.id) === selectedId);
    if (option) {
      setValue({ id: option.id, name: option.name });
    }
  };

  return (
    <Select value={value?.id || undefined} onValueChange={handleValueChange}>
      {/*
        ── ONE CHEVRON, AND IT IS THE PRIMITIVE'S ───────────────────────────────────────────────
        This trigger rendered a second `ChevronDown` of its own, right after `SelectValue`, so the
        Metadata type control showed TWO arrows side by side — a blue one from here and the grey
        one `SelectTrigger` draws itself. Neither was a separate control: both sat inside the one
        Radix trigger button, so the duplicate was decoration that read as a second affordance.

        It was not always a duplicate. `packages/ui`'s `SelectTrigger` gained a built-in indicator
        later, on the finding that "none of the ~100 call sites supplied their own" — true of every
        call site but this one, which had been compensating for its absence since before that. So
        the fix is to drop the local one rather than to suppress the shared one: the primitive's is
        the one every other select in the app already shows, and it is `aria-hidden`, which keeps
        the trigger's accessible name and keyboard behaviour exactly as they are.
      */}
      <SelectTrigger
        className={clsx(className, "text-sm flex items-center justify-between")}
      >
        <SelectValue placeholder={placeholder}>
          {value?.name || value?.id || placeholder}
        </SelectValue>
      </SelectTrigger>

      <SelectContent>
        {options.map((opt: any) => (
          <SelectItem key={opt.id} value={String(opt.id)}>
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground truncate max-w-[160px]">
                {opt.name}
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
